import React from 'react';
import { Container } from '../../components/ui/Container';
export function ArabicCodeOfConduct() {
  return <section className="py-16 text-right md:py-24" dir="rtl" data-id="element-3631" data-mp="3q1lj23e6q6yq">
      <Container data-id="element-3632" data-mp="3l9txy8dsstfz">
        <article className="mx-auto max-w-4xl" data-id="element-3633" data-mp="3l9al36308v8t">
          <h1 className="font-display text-4xl font-semibold leading-[1.5] text-ink-900 md:text-6xl" data-id="element-3634" data-mp="3l7zbgpmvot9s">
            مدونة السلوك
          </h1>
          <p className="mt-4 text-ink-500" data-id="element-3635" data-mp="3bc5sooikg3jk">
            <strong data-id="element-3636" data-mp="3bd7g7sgrqii6">آخر تحديث:</strong> 1 فبراير 2026
          </p>

          <aside className="mt-8 rounded-2xl border border-sage-200 bg-sage-50 px-6 py-5 shadow-soft" data-id="element-3637" data-mp="36c9yti3l1shq">
            <p className="leading-loose text-ink-700" data-id="element-3638" data-mp="32bzjhetwhpq7">
              نلتزم في جميع تعاملاتنا بمعياري الأمانة والأدب، بما يضمن أن تعكس أعمالنا
              المهنية أعلى القيم الأخلاقية.
            </p>
          </aside>

          <div className="mt-10 space-y-8 leading-loose text-ink-700" data-id="element-3639" data-mp="10j2yp0a6v8sw">
            <p data-id="element-3640" data-mp="vk8k6aj986el">
              تنطبق مدونة السلوك هذه على جميع أصحاب المصلحة، بمن فيهم الموظفون
              والمعلّمون والمتطوعون والشركاء والمشاركون في البرامج.
            </p>

            <h2 className="mt-12 font-display text-2xl font-semibold leading-[1.5] text-ink-900 md:text-3xl" data-id="element-3641" data-mp="1ir5duf2r1faf">
              السلوك المتوقع
            </h2>
            <p data-id="element-3642" data-mp="14tgrf2t1a039">نتوقع من جميع الأفراد المرتبطين بالمركز إظهار ما يلي:</p>
            <p data-id="element-3643" data-mp="19rqkn7v76qm8">
              <strong data-id="element-3644" data-mp="19r8sonfkiyk4">• الاحترام:</strong> معاملة جميع الأفراد بكرامة واحترام.
            </p>
            <p data-id="element-3645" data-mp="1xhkx3oblud5y">
              <strong data-id="element-3646" data-mp="1xh33kzgbud1q">• الشمول:</strong> مراعاة الحساسية الثقافية وتعزيز بيئة مرحبة
              وداعمة لجميع الأطفال والأسر.
            </p>
            <p data-id="element-3647" data-mp="1nqq8idavz1hc">
              <strong data-id="element-3648" data-mp="1nr9sdzk3jzy0">• النزاهة:</strong> التصرف وفق معايير أخلاقية ومهنية عالية.
            </p>
            <p data-id="element-3649" data-mp="1sorub5zp5ewi">
              <strong data-id="element-3650" data-mp="1soa0sh4f5esa">• الحدود:</strong> الحفاظ على تواصل مناسب وحدود مهنية واضحة.
            </p>

            <h2 className="mt-12 font-display text-2xl font-semibold leading-[1.5] text-ink-900 md:text-3xl" data-id="element-3651" data-mp="2ge49qnlmaj79">
              السلوك المحظور
            </h2>
            <p data-id="element-3652" data-mp="2v1ujirp29eub">تُحظر السلوكيات التالية منعًا باتًا:</p>
            <p data-id="element-3653" data-mp="2v1chfefpw6eh">• التمييز أو التحرّش أو التنمر بأي شكل من الأشكال.</p>
            <p data-id="element-3654" data-mp="2q2hzeepkqlvf">• إساءة استخدام السلطة أو المنصب.</p>
            <p data-id="element-3655" data-mp="2q0oqesrhnpk9">• التواصل غير المناسب أو ذي الإيحاءات الجنسية.</p>
            <p data-id="element-3656" data-mp="2l2di4mgudn45">• إساءة استخدام موارد المنظمة أو ملكيتها الفكرية أو سرقتها.</p>

            <h2 className="mt-12 font-display text-2xl font-semibold leading-[1.5] text-ink-900 md:text-3xl" data-id="element-3657" data-mp="2g5daw889aebg">
              المخالفات
            </h2>
            <p data-id="element-3658" data-mp="2c535awodlpx4">
              تُحقَّق مخالفات هذه المدونة، وقد تؤدي إلى الإبعاد الفوري من البرامج أو
              إنهاء العمل أو إنهاء اتفاقيات الشراكة.
            </p>
          </div>
        </article>
      </Container>
    </section>;
}